
export const intlToggle = (currencyCookie, countryCookie) => {
    var $catBar = $('#topbar-wrapper #main-nav ul li.show-when-international');
    $('.hide-when-international').css('display', 'none');
    $('.international-mobile-menu').css('padding-top', '60px');
    $('.show-when-international').css('display', 'inline-block');
    $('#feedbackInMobileMenuInternational.show-when-international').css('display', 'block');
    $('.mobilePage footer .show-when-international').css('display', 'block');
    $('#topbar-wrapper #main-nav ul').not('#topbar-wrapper #main-nav ul.children').addClass('isInternational');
    $('#topbar-wrapper #main-nav ul.isInternational li.show-when-international').show();
    $('#main-nav .parent-7').parent().hide(); //dresses desktop
    $('#main-nav .parent-6').parent().next().show(); //beauty desktop
    $(".mobile-menu ul li a:contains('Dresses')").closest('li').hide(); //dresses mobile
    $(".mobile-menu ul li a:contains('Beauty')").closest('li').show(); //beauty desktop
    $(".mobile-menu-categories .category-list li a:contains('Beauty')").closest('li').show(); //beauty desktop

    // for the category bar
    if (countryCookie == 'US') {
        $catBar.hide();
    }

    /*$('.price-number').each(function() {
        intlConvertLogic(this);
    });*/
};
